document.addEventListener('DOMContentLoaded', () => {
    const selectors = {
        mainPage: '[data-main-page]',
        pageWrapper: '#content .container',
    }

    const page = document.querySelector(selectors.mainPage);
    const pageWrapper = document.querySelector(selectors.pageWrapper);
    const backgroundColorClass = page.dataset.mainPageBackground;
    const textColorClass = page.dataset.mainPageText;

    if(backgroundColorClass) {
        pageWrapper.classList.add(backgroundColorClass);
    }

    if(textColorClass) {
        pageWrapper.classList.add(textColorClass);
    }
});
